'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function AddressValidationHelpModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Neden bu kontrolü yapıyoruz?</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 text-sm text-hzc_beige_900 text-left pt-2">
              <p>
                Teslimat bölgemiz mahalle bazında planlanır. Adres ile seçilen mahalle uyuşmadığında
                sipariş yanlış bölgeye düşebilir ve teslimat gecikebilir.
              </p>
              <p>
                Bu yüzden adresinizi çözümleyip en uygun mahalleleri öneriyoruz. Böylece kurye doğru
                bölgeye yönlendirilir ve dağıtım hatalarının önüne geçilir.
              </p>
              <p>
                Önerilen mahallelerden birini seçebilir, adresinizi güncelleyebilir veya teslimat
                günü ve saatiniz uygunsa yeni mahalle ile devam edebilirsiniz.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <Button
          className="w-full rounded-full bg-hzc_purple_500 hover:bg-hzc_purple_500"
          onClick={() => onOpenChange(false)}
        >
          Anladım
        </Button>
      </DialogContent>
    </Dialog>
  );
}
